<template>
  <div class="warehouse">
    <headers></headers>
    <div class="banner">
      <img src="../assets/banner22@2x.png" width="100%" alt />
    </div>
    <main>
      <div class="main-top">
        <h2>产品功能</h2>
      </div>
      <el-row style="margin: 40px 0;" class="main-top1">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h3 style="font-weight: 800;font-size: 36px;margin-bottom: 19px;">产品功能</h3>
            <p style="font-size: 16px;">PRODUCT FUNCTION</p>
          </div>
        </el-col>
      </el-row>
      <el-row class="main-top2">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h4>收银机 仓库版管理</h4>
            <p>商品出库/唯一标签打印/问题商品管理…</p>
          </div>
        </el-col>
      </el-row>

      <el-row class="shangpin">
        <el-col :span="24" style="display:flex;justify-content: center">
          <div class="box">
            <div class="infobox">
              <p style="height:50px">
                <img src="../assets/仓库-块@2x.png" alt />
              </p>
              <p>分店出入退</p>
              <p>信息及时反馈</p>
              <p>人员编号记录</p>
              <p>调拨单层级审核</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/商品erp系统@2x.png" alt width="50px" />
              </p>
              <p>问题商品</p>
              <p>问题商品依次选</p>
              <p>处理结果及时看</p>
              <p>条目一一对应</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/扫码-full@2x.png" alt />
              </p>
              <p>打印标签</p>
              <p>唯一码打印</p>
              <p>商品码一对一</p>
              <p>无需重复查找</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/成品检测@2x.png" alt />
              </p>
              <p>库存详情</p>
              <p>品牌品类</p>
              <p>记录分明</p>
              <p>持续销售</p>
              <!-- <p>及时供应</p> -->
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row class="shangpin">
        <el-col :span="24" style="display:flex;justify-content: center">
          <div class="box">
            <div class="infobox">
              <p style="height:50px">
                <img src="../assets/价格策略@2x.png" alt />
              </p>
              <p>结算方式</p>
              <p>支付宝,微信,转账,等...</p>
              <p>支持各种支付方式</p>
              <p>支付过程方便快捷</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/筛选@2x.png" alt width="50px" />
              </p>
              <p>商品筛选</p>
              <p>分类明确</p>
              <p>快速查找</p>
              <p>&nbsp;</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/盘点@2x.png" alt />
              </p>
              <p>历史记录</p>
              <p>各种单据凭证</p>
              <p>数据存档</p>
              <p>便于查找</p>
            </div>
          </div>
          <div class="box">
            <div class="infobox">
              <p>
                <img src="../assets/我的绩效@2x.png" alt />
              </p>
              <p>开发中</p>
              <p>服务在线</p>
              <p>开发在线</p>
              <p>追求品质与卓越</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 移动端商品 -->
      <div class="smallshangpin">
        <ul>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/仓库-块@2x.png" alt />
              </p>
              <p>分店出入退</p>
              <p>信息及时反馈</p>
              <p>人员编号记录</p>
              <p>调拨单层级审核</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/商品erp系统@2x.png" alt width="50px" />
              </p>
              <p>问题商品</p>
              <p>问题商品依次选</p>
              <p>处理结果及时看</p>
              <p>条目一一对应</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/扫码-full@2x.png" alt />
              </p>
              <p>打印标签</p>
              <p>唯一码打印</p>
              <p>商品码一对一</p>
              <p>无需重复查找</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/成品检测@2x.png" alt />
              </p>
              <p>库存详情</p>
              <p>品牌品类</p>
              <p>记录分明</p>
              <p>持续销售</p>
              <!-- <p>及时供应</p> -->
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/价格策略@2x.png" alt />
              </p>
              <p>结算方式</p>
              <p>支付宝,微信,转账,等...</p>
              <p>支持各种支付方式</p>
              <p>支付过程方便快捷</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/筛选@2x.png" alt width="50px" />
              </p>
              <p>商品筛选</p>
              <p>分类明确</p>
              <p>快速查找</p>
              <p>&nbsp;</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/盘点@2x.png" alt />
              </p>
              <p>历史记录</p>
              <p>各种单据凭证</p>
              <p>数据存档</p>
              <p>便于查找</p>
            </div>
          </li>
          <li>
            <div class="infobox1">
              <p>
                <img src="../assets/我的绩效@2x.png" alt />
              </p>
              <p>开发中</p>
              <p>服务在线</p>
              <p>开发在线</p>
              <p>追求品质与卓越</p>
            </div>
          </li>
        </ul>
      </div>
    </main>
    <!-- 技术规格 -->
    <div class="science">
      <div class="smallscience">
        <h2>技术规格</h2>
      </div>
      <el-row class="science_top">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h4>收银机 技术规格</h4>
            <p>全功能触摸一体收银机</p>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col class="smalllunbotu" :xs="{span:16,offset:4}">
          <img src="../assets/tu@2x.png" alt width="100%" />
        </el-col>
        <el-col :sm="{span:6,offset:6}" :xs="{span:24,offset:4}" class="xiangqing">
          <div class="grid-content bg-purple science_left">
            <p>技术规格</p>
            <p>主显显示屏：15.6寸电容触摸</p>
            <p>客显显示屏：9寸宽视角</p>
            <p>&nbsp;</p>
            <p>系统：Android6.0.1</p>
            <p>主频：1.8GHZ</p>
            <p>内存：2G</p>
            <p>闪存：8GB</p>
            <p>通讯：以太网/WIFI/蓝牙</p>
            <p>内置打印机装纸容量：直径80MM</p>
            <p>打印速度：260MM/秒</p>
          </div>
        </el-col>
        <el-col :sm="{span:7}" class="lunbotu">
          <div class="grid-content bg-purple-light">
            <el-carousel indicator-position="outside">
              <el-carousel-item>
                <img src="../assets/tu@2x.png" alt width="100%" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/tu@2x.png" alt width="100%" />
              </el-carousel-item>
              <el-carousel-item>
                <img src="../assets/tu@2x.png" alt width="100%" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
      </el-row>

      <el-row style="margin-top:10px;">
        <el-col :lg="{span:16,offset:4}" :md="{span:24,offset:0}">
          <el-row>
            <el-col :span="8" :xs="{span:24,offset:4}">
              <div class="yyy">
                <img src="../assets/材料@2x.png" alt width="20px;" />
                <span>主显示屏采用军工级别铝合金材料</span>
              </div>
            </el-col>
            <el-col :span="8" :xs="{span:24,offset:4}">
              <div class="yyy">
                <img src="../assets/塑料@2x.png" alt width="20px;" />
                <span>机器壳身采用高强度abs塑料</span>
              </div>
            </el-col>
            <el-col :span="8" :xs="{span:24,offset:4}">
              <div class="yyy">
                <img src="../assets/小票打印机@2x.png" alt width="20px;" />
                <span>自带切纸功能的热敏小票打印机</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!-- 特色功能 -->
    <div class="feature">
      <div class="feature_top">
        <h2>特色功能</h2>
      </div>
      <el-row style class="feature-top">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h4 style>特色功能</h4>
            <p style>为眼镜行业专业定制</p>
          </div>
        </el-col>
      </el-row>

      <el-row class="feature-content">
        <el-col :span="24" style="display: flex;justify-content: center;">
          <div class="bigbox-left">
            <div class="boxs">
              <p>
                <img src="../assets/ckkc.png" alt width="50px" />
              </p>
              <p style="font-size: 24px; margin: 14px 0 20px 0;">查看库存</p>
              <p style="font-size: 20px;color:#666;">
                商家可在pda/微信服务号/商家版收
                <br />银机下加工单；加工中心自行下加工单。
              </p>
            </div>
            <div class="boxs">
              <p>
                <img src="../assets/打印机@2x.png" alt width="50px" />
              </p>
              <p style="font-size: 24px; margin:  14px 0 20px 0;">打印标签</p>
              <p style="font-size: 20px;color:#666;">
                在筛选完商品后，点击打印标签，
                <br />生 成单个唯一二维码。
              </p>
            </div>
          </div>

          <div class="boxs_z">&nbsp;</div>

          <div class="bigbox-right">
            <div class="boxs">
              <p>
                <img src="../assets/spcr.png" alt width="50px" />
              </p>
              <p style="font-size: 24px; margin:  14px 0 20px 0;">商品出入库</p>
              <p style="font-size: 20px;color:#666;">
                在打印标签页面中，入库确认，
                <br />等待 收银机打印入库。
              </p>
            </div>
            <div class="boxs">
              <p>
                <img src="../assets/历史记录@2x.png" alt width="50px" />
              </p>
              <p style="font-size: 24px; margin:  14px 0 20px 0;">历史记录</p>
              <p style="font-size: 20px;color:#666;">
                历史记录中查看商品出库订单，
                <br />库单中 包括库存商品详情/作废此单/重新配货…
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 移动端 -->
      <div class="smallfeature">
        <ul>
          <li>
            <p>
              <img src="../assets/ckkc.png" alt />
              <span>查看库存</span>
            </p>
            <p>筛选出出库商品后，可在库存一栏中查看到当前品牌当前系列的总仓库。</p>
          </li>
          <li>
            <p>
              <img src="../assets/打印机@2x.png" alt />
              <span>打印标签</span>
            </p>
            <p>在筛选完商品后，点击打印标签，生 成单个唯一二维码。</p>
          </li>
          <li>
            <p>
              <img src="../assets/spcr.png" alt />
              <span>商品出入库</span>
            </p>
            <p>在打印标签页面中，入库确认，等待 收银机打印入库。</p>
          </li>
          <li>
            <p>
              <img src="../assets/历史记录@2x.png" alt />
              <span>历史记录</span>
            </p>
            <p>历史记录中查看商品出库订单，库单中 包括库存商品详情/作废此单/重新配货…</p>
          </li>
        </ul>
      </div>
    </div>

    <!-- 样机细节展示 -->
    <div class="proto">
      <div class="smallproto">
        <h2>样机细节展示</h2>
      </div>
      <el-row class="proto_top">
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <h4>样机细节展示</h4>
            <p>带给您不一样的视觉体验</p>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <div class="proto_b">
            <img src="../assets/yangji.png" alt />
            <br />
            <img src="../assets/1Pro3-1@2x.png" width="620px" alt />
            <br />
            <img src="../assets/1Pro3-2@2x.png" width="620px" alt />
            <br />
            <img src="../assets/1Pro3-3@2x.png" width="620px" alt />
          </div>
        </el-col>
      </el-row>
    </div>
    <footers></footers>
  </div>
</template>

<script>
import header from "../components/headers";
import footer from "../components/footer";
export default {
  components: {
    headers: header,
    footers: footer
  }
};
</script>

<style lang="less" scoped>
.warehouse {
  main {
    text-align: center;
    margin-bottom: 100px;
    @media screen and (max-width: 850px) {
      .main-top {
        display: block;
      }
      .main-top1 {
        display: none;
      }
      .shangpin {
        display: none;
      }
      .smallshangpin {
        display: block;
      }
    }
    @media screen and (min-width: 850px) {
      .main-top {
        display: none;
      }
      .main-top1 {
        display: block;
      }
      .shangpin {
        display: block;
      }
      .smallshangpin {
        display: none;
      }
    }
    .main-top {
      text-align: left;
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;

        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
    }
    .main-top2 {
      margin: 20px 0;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
      }
      p {
        font-size: 18px;
      }
      @media screen and (max-width: 850px) {
        h4 {
          font-size: 14px;
          margin-bottom: 9px;
        }
        p {
          font-size: 9px;
        }
      }
    }
    .box {
      // padding: 20px 31px;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        transform: translateY(-4px);
      }
      display: flex;
      justify-content: flex-start;
      margin: 24px 19px;
      .infobox {
        padding: 50px 0;
        border: 1px solid #bdddfe;
        box-shadow: 0px 10px 12px #f0f4fd;
        border-radius: 4px;
        min-width: 250px;
        max-width: 250px;
        p {
          font-size: 14px;
          line-height: 25px;
          color: #666;
          font-family: MicrosoftYaHei;
          &:nth-of-type(1) {
            height: 50px;
          }
          &:nth-of-type(2) {
            font-size: 18px;
            margin: 17px 0;
          }
          img {
            height: 100%;
          }
        }
      }
    }

    .smallshangpin {
      padding: 0 15px;
      ul {
        overflow: hidden;
        width: 100%;

        li {
          width: 48%;
          // height: 150px;
          margin-right: 12px;
          margin-bottom: 15px;
          padding: 20px 10px;
          float: left;
          border-radius: 3px;
          border: 1px solid #258ffc;
          box-shadow: 0 8px 10px rgba(0, 0, 0, 0.2);
          &:nth-of-type(even) {
            margin-right: 0;
          }
          p {
            font-size: 10px;
            line-height: 20px;
            white-space: nowrap;
            &:nth-of-type(1) {
              height: 40px;
              img {
                width: 30px;
              }
            }
            &:nth-of-type(2) {
              font-size: 16px;
              line-height: 35px;
            }
          }
        }
      }
    }
  }
  .science {
    @media screen and (max-width: 850px) {
      .smallscience {
        display: block;
        h2 {
          font-size: 16px;
          color: #2e2e2e;
          font-weight: 400;
          margin: 11px 0;
          position: relative;
          padding-left: 28px;

          &::after {
            content: "";
            background-color: #258ffc;
            border-radius: 5.5px;
            width: 4px;
            height: 16px;
            overflow: hidden;
            position: absolute;
            top: 3px;
            left: 13px;
          }
        }
      }
      .lunbotu {
        display: none;
      }
      .smalllunbotu {
        display: block;
      }
      .xiangqing {
        margin-top: 40px;
        margin-bottom: 40px;
      }
    }
    @media screen and (min-width: 850px) {
      .smallscience {
        display: none;
      }
      .lunbotu {
        display: block;
      }
      .smalllunbotu {
        display: none;
      }
    }
    background-color: #f0efef;
    padding: 50px 0;
    padding-bottom: 100px;
    .science_top {
      text-align: center;
      margin: 40px 0;
      margin-top: -20px;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
        margin-top: 30px;
      }
      p {
        font-size: 18px;
      }
      @media screen and (max-width: 850px) {
        h4 {
          font-size: 14px;
          margin-bottom: 9px;
        }
        p {
          font-size: 9px;
        }
      }
    }
    .science_left {
      p {
        line-height: 25px;
      }
    }
    .yyy {
      padding: 10px 0;
      cursor: pointer;
      transition: all 1s;
      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 3px 3px #eee;
      }
      img {
        margin-right: 5px;
        vertical-align: middle;
      }
      span {
        color: #2891fc;
        vertical-align: middle;
      }
    }
  }
  .feature {
    @media screen and (max-width: 850px) {
      .feature-top {
        display: none;
      }
      .feature_top {
        display: block;
      }
      .feature-content {
        display: none;
      }
      .smallfeature {
        display: block;
      }
    }
    @media screen and (min-width: 850px) {
      .feature-top {
        display: block;
      }
      .feature_top {
        display: none;
      }
      .feature-content {
        display: block;
      }
      .smallfeature {
        display: none;
      }
    }
    .feature_top {
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;

        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
    }
    .feature-top {
      margin: 80px 0;
      text-align: center;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
      }
      p {
        font-size: 18px;
      }
    }
    .bigbox-left {
      float: left;
      width: 440px;
      margin-right: 47px;
    }
    .bigbox-right {
      float: left;
      width: 440px;
    }
    .boxs {
      float: left;
      padding: 30px 40px;
      cursor: pointer;
      margin-bottom: 50px;
      width: 440px;
      border-radius: 4px;
      &:hover {
        transform: translate(-5px, -5px);
        transition: all 1s;
        box-shadow: 0px 0px 15px #d2e8ff;
      }
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .boxs_z {
      width: 1px;
      height: 520px;
      background-color: #d2d2d2;
      float: left;
      margin-right: 57px;
    }
    // 移动端
    .smallfeature {
      padding: 15px;
      ul {
        overflow: hidden;
        padding: 0 40px;
        li {
          margin-bottom: 40px;
          p {
            font-size: 12px;
            vertical-align: middle;
            img {
              width: 37px;
              vertical-align: middle;
            }
            span {
              font-weight: 600;
              margin-left: 10px;
            }
            &:nth-of-type(2) {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }

  .proto {
    background-color: #fff;
    padding: 40px 0;
    .smallproto {
      @media screen and (min-width: 850px) {
        display: none;
      }
      h2 {
        font-size: 16px;
        color: #2e2e2e;
        font-weight: 400;
        margin: 11px 0;
        position: relative;
        padding-left: 28px;

        &::after {
          content: "";
          background-color: #258ffc;
          border-radius: 5.5px;
          width: 4px;
          height: 16px;
          overflow: hidden;
          position: absolute;
          top: 3px;
          left: 13px;
        }
      }
    }
    .proto_top {
      text-align: center;
      margin: 40px 0;
      margin-top: -20px;
      h4 {
        font-weight: 400;
        font-size: 28px;
        margin-bottom: 19px;
        margin-top: 30px;
      }
      p {
        font-size: 18px;
      }
      @media screen and (max-width: 850px) {
        h4 {
          font-size: 14px;
          margin-bottom: 9px;
        }
        p {
          font-size: 9px;
        }
      }
    }
    .proto_b {
      text-align: center;
      @media screen and (max-width: 850px) {
        img {
          width: 100%;
          &:nth-of-type(1) {
            width: 70%;
          }
        }
      }

      img {
        margin: 40px 0;
        transition: all 1s;
        cursor: pointer;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
}
</style>